const genericModelTypes = {
  suggestedPlace: 1,
  noService: 2,
  noLevel: 3,
  suggestedPlaceNew: 4,
};

export default genericModelTypes;

/* 
  // /generic
    {
      type: 1
      full_name: 
      email: 
      phone:
      date_of_birth: "1/1/2014",
      consent_marketing:  // potem będą tu nazwy podane w agreementach
      consent_policy:
      consent_processing:
      generic_info: 'propozycja miejsca',
    }


    {
      type: 2   // w tym franchise nie było wybranego wcześniej service
      email:
      phone:
      generic_info: {
        service: { // (to co jest w testStore)
          type: 'service', 
          value: 'winter_workshops',  // jakis slug
          title: 'Warsztaty ferie',  // to co sie wyswietla
          disabled: false,
          description: 'cos tam',
        }, 
        franchise: {id, name, signups_active...}, (to samo co z /api/v2/franchises)
      }
    }

    {
      type: 3   // w tym franchise nie ma levelu dla wybranego wieku
      email:
      phone:
      generic_info: {
        service: { // (to co jest w testStore)
          type: 'service', 
          value: 'winter_workshops',  // jakis slug
          title: 'Warsztaty ferie',  // to co sie wyswietla
          disabled: false,
          description: 'cos tam',
        }, 
        franchise: {id, name, signups_active...}, (to samo co z /api/v2/franchises)
        age: {
          text: '14 lat',
          value: 14
        }
      }
    }
*/
